// extracted by mini-css-extract-plugin
export default {"table":"Table_table__7wj0E","empty":"Table_empty__8saIm","striped":"Table_striped__5bKk-","hoverable":"Table_hoverable__qGnyj","compact":"Table_compact__F0YCL"};